/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';

import IUnidades from 'Infotrack@Modelos/smartStock/unidades/entidades/unidades';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IUnidades>> => [
    {
        title: formatMessage({ id: 'unidades.descripcionTipoUnidad' }),
        field: 'DescripcionTipoUnidad',
    },
    {
        title: formatMessage({ id: 'unidades.descripcionUnidad' }),
        field: 'DescripcionUnidad',
    },
    {
        title: formatMessage({ id: 'unidades.abreviatura' }),
        field: 'Abreviatura',
    },
    {
        title: formatMessage({ id: 'unidades.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, unidades?: IUnidades) => void,
    cargarUnidades: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (unidades: IUnidades) => void
): Array<Action<IUnidades>> => [
    {
        icon: 'refresh',
        onClick: cargarUnidades,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IUnidades),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IUnidades),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IUnidades> = {
    maxBodyHeight: 500,
};
